/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcGenerateV1TradeConfirmationsJobState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_GENERATE_V1_TRADE_CONFIRMATIONS_JOB_STATE_ENTITY_NAME = 'ixc.generate.v1.TradeConfirmationsJob';
export const ixcGenerateV1TradeConfirmationsJobStateEntity = new schema.Entity<IxcGenerateV1TradeConfirmationsJobState>(IXC_GENERATE_V1_TRADE_CONFIRMATIONS_JOB_STATE_ENTITY_NAME, {}, { idAttribute: 'jobId' });

